import humps from 'humps'

export function toSnakeCase(data) {
  return humps.decamelizeKeys(data, {separator: "_"})
}

export function toCamelCase(data) {
  return humps.camelizeKeys(data)
}